import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges Tailwind classes so a later class wins over an earlier conflicting one.
 * Without this, `cn('p-2', 'p-4')` would emit both and let CSS source order decide.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
